<template>
    <v-menu ref="dateMenu" :key="di.Id" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
        <template v-slot:activator="{ on, attrs }">
        <v-text-field :key="di.Id"
            v-model="di.Value"
            :label="(di.Caption.length === 0) ? di.Name : di.Caption"
            persistent-hint
            prepend-icon="mdi-calendar-range"
            v-bind="attrs"
            v-on="on"
            :disabled="disabled"
            :required="di.Mandatory"
            :rules="rules"
        ></v-text-field>
        </template>
        <v-date-picker :key="di.Id" v-model="pickerDate" no-title @input="menu = false"></v-date-picker>
    </v-menu>
</template>

<script>
export default {
  name: 'DateField',
  props: ['di', 'disabled', 'rules'],
  data () {
    return {
      menu: false,
      pickerDate: new Date().toISOString().substr(0, 10)
    }
  },
  watch: {
    pickerDate (val) {
      console.log('change date value', val)
      this.di.Value = this.formatDate(val.toString())
      this.$emit('change', this.di)
    }
  },
  methods: {
    formatDate (date) {
      if (typeof date === 'string') date = new Date(date)
      console.log('formatDate', date)
      const year = date.getFullYear()
      const rawMonth = date.getMonth() + 1
      const mont = (rawMonth + 1 < 10) ? '0' + rawMonth : rawMonth.toString()
      const day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate().toString()
      return day + '.' + mont + '.' + year
    },
    parseDate (strDate) {
      let [day, moth, year] = strDate.split('.')
      year = year.substring(0, 4)
      return new Date(year, moth, day)
    }
  }
}
</script>
